export const SECTION_IDS = [
  'hero',
  'paso-1',
  'paso-2',
  'paso-3',
  'beneficios',
  'datos',
  'cta-final',
] as const;

export type SectionId = (typeof SECTION_IDS)[number];

export function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}
